import { AppThunk } from 'app/store'

import { obtainToken } from 'services/auth'
import { parseError } from 'utils/errors'
import { slice } from './reducer'

export const { loginStart, loginSuccess, loginFailed } = slice.actions

export const login = (
  username: string,
  password: string,
  callback: () => void = () => null
): AppThunk => async (dispatch) => {
  dispatch(loginStart())
  try {
    const data = await obtainToken(username, password)
    dispatch(loginSuccess(data))
    callback()
  } catch (err) {
    dispatch(loginFailed(parseError(err)))
  }
}
